import Router from 'js-dom-router';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
import { TextPlugin } from 'gsap/TextPlugin';
import { SplitText } from './lib/SplitText3';

import { lenis } from './common';
import { gsapCounter } from './lib/gsapEffects/gsapCounter';
import { initTopbar } from './components/topBar';
import { initLandingPage } from './pages/landing';
import { initDetailsGroup } from './components/detailsGroup';
import { initTextInput } from './components/textInput';
import { initFooter } from './components/footer';
import { initTelInputs } from './components/telInput';
import { scheduleTask } from './lib/task';
import { initTooltips } from './components/tooltips';
import { initRequestQuotePage } from './pages/requestQuote';
import { initBlockCard01s } from './components/blockCard01';
import { initBlockCard02s } from './components/blockCard02';
import { initBlockCredits01s } from './components/blockCredits01';
import { initKnowledgeBases } from './components/knowledgeBase';
import { initWaveBgs } from './components/waveBg';
import { initAiReports } from './components/aiReport';
import { initServiceHero } from './components/serviceHero';
import { initAllBlockClients } from './components/blockClients';
import { initBlockLeadForms } from './components/blockLeadForm';
import { initArticle } from './components/article';
import { initAllSideBySideCompares } from './components/sideBySideCompare';
import { initAllSubscribeBlocks } from './components/subscribeBlock';
import { initAllArticleSearchBlocks } from './components/articlesSearch';
import { initSelects } from './components/select';
import { initAllCaseStudyBlocks } from './components/blockCaseStudy';
import { initAllBlockCards } from './components/blockCard';
import { initJsFluidMultipliers } from './lib/fluidSizings';

if (import.meta.env?.VITE_TARGET === 'staticMarkup') {
  import('./targetStaticMarkup');
}

// Global js
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TextPlugin);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);
gsap.registerEffect(gsapCounter());

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);

initServiceHero();
initJsFluidMultipliers();
scheduleTask(initTopbar);
scheduleTask(initDetailsGroup);
scheduleTask(initTextInput);
scheduleTask(initTelInputs);
scheduleTask(initFooter);
scheduleTask(initTooltips);
scheduleTask(initBlockCard01s);
scheduleTask(initBlockCard02s);
scheduleTask(initAllBlockCards);
scheduleTask(initBlockCredits01s);
scheduleTask(initKnowledgeBases);
scheduleTask(initWaveBgs);
scheduleTask(initAiReports);
scheduleTask(initAllBlockClients);
scheduleTask(initBlockLeadForms);
scheduleTask(initArticle);
scheduleTask(initAllSideBySideCompares);
scheduleTask(initAllSubscribeBlocks);
scheduleTask(initAllArticleSearchBlocks);
scheduleTask(initAllCaseStudyBlocks);
scheduleTask(initSelects);

// Per page type js
new Router(document.body)
  .on('page--is-landing', initLandingPage)
  .on('page--is-request-quote', initRequestQuotePage)
  .ready();

console.log('🪐 Global JS initialized.');
